var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('h3',[_vm._v("Vertical Image")]),_c('app-placeholder-vertical',{attrs:{"imageId":_vm.form.imageId},on:{"upload":_vm.onUpload}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }